<template>
    <v-dialog :value="visibility" scrollable persistent :fullscreen="!$vuetify.breakpoint.smAndUp">

    <v-card>
      <v-card-text>
        <v-row>
          <span class="dialog-headline ml-5"> Editar Professor </span>
        </v-row>

        <v-form no-gutters>
          <v-container>
            <div id="form_personal_data">

              <v-img :src="form.image" class="width_image" />

              <CloudinaryUpload
                @uploaded-image="form.image = $event"
                :from_admin="true"
                :image="form.image"
                :edit="true"
              />

              <v-col cols="6">
                <v-text-field
                  v-model="form.name"
                  label="Nome completo"
                  class="big-purple-text-field"
                ></v-text-field>
              </v-col>

              <v-expansion-panels
                style="max-width: 420px;"
                class="mb-2 mt-3"
              >
                <v-expansion-panel>
                  <v-expansion-panel-header> Alterar Senha </v-expansion-panel-header>
                  <v-expansion-panel-content>

                    <v-text-field
                      v-model="form.new_password"
                      label="Nova senha"
                      type="password"
                    />

                    <v-text-field
                      v-model="form.password_confirmation"
                      label="Confirmar nova senha"
                      type="password"
                    />

                    <p class="grey--text"> Clique em salvar para alterar a senha. </p>
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </v-expansion-panels>

              <v-col col-12>
                <v-text-field
                  v-if="form && form.user"
                  readonly
                  v-model="form.user.email"
                  disabled
                  label="E-mail"
                  class="text-field large"
                ></v-text-field>
              </v-col>

              <v-col cols="10">
                <v-text-field
                  v-model="form.nickname"
                  label="Como você gosta de ser chamado?"
                ></v-text-field>
              </v-col>

              <v-col cols="10">
                <template>
                  <v-menu
                    ref="menu"
                    v-model="menu"
                    :close-on-content-click="false"
                    transition="scale-transition"
                    offset-y
                    full-width
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        cols="1"
                        :value="computedFormatBithDate"
                        label="Data de nascimento"
                        append-icon="mdi-calendar"
                        readonly
                        v-on="on"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      ref="picker"
                      v-model="form.bith_date"
                      full-width
                      @change="save"
                      locale="pt-BR"
                      style="max-width: 600px;"
                    ></v-date-picker>
                  </v-menu>
                </template>
              </v-col>

              <v-col cols="6">
                <v-text-field
                  v-model="form.cpf"
                  label="CPF"
                  v-mask="cpfMask"
                />
              </v-col>


               <v-col col-12>
                  <v-text-field
                    v-model="form.phone"
                    :rules="[() => !!form.phone || 'Campo obrigatório']"
                    label="Telefone de contato"
                    class="text-field medium"
                    v-mask="phoneMask"
                  ></v-text-field>
                </v-col>

                <div id="form_address_data">
                  <p class="form-title">Dados de Endereço</p>

                  <v-col cols="12">
                    <v-select
                      v-if="affiliates"
                      v-model="form.affiliate_id"
                      :items="affiliates"
                      :menu-props="{ maxHeight: '400' }"
                      label="Marcar aulas em"
                      item-text="name"
                      item-value="id"
                      persistent-hint
                    ></v-select>
                  </v-col>

                  <v-col cols="12">
                    <v-text-field
                      v-model="form.cep"
                      label="CEP"
                      v-mask="cepMask"
                      @change="cep"
                    />
                  </v-col>

                  <v-col cols="6">
                    <!-- <v-select
                      v-model="form.state"
                      :items="estados_br"
                      label="Santa Catarina"
                      disabled
                      value="SC"
                    ></v-select> -->
                    <v-text-field
                      v-model="form.state"
                      label="Estado"
                    />
                  </v-col>

                  <v-col cols="9">
                    <!-- <v-select
                      v-model="form.city"
                      :items="cidades_br"
                      label="Florianópolis / Grande Florianóplis"
                      value="Florianópolis"
                    ></v-select> -->
                    <v-text-field
                      v-model="form.city"
                      label="Cidade"
                    />

                  </v-col>

                  <v-col cols="12">
                    <v-text-field
                      v-model="form.neighborhood"
                      label="Bairro"
                    ></v-text-field>
                  </v-col>

                  <v-col cols="12">
                    <v-text-field
                      v-model="form.street"
                      label="Rua"
                      persistent-hint
                      hint="Rua, avenida, logradouro, viela, etc"
                    ></v-text-field>
                  </v-col>

                  <v-col cols="4">
                    <v-text-field v-model="form.number" label="Número"></v-text-field>
                  </v-col>

                  <v-col cols="8">
                    <v-text-field
                      v-model="form.complement"
                      label="Complemento"
                      persistent-hint
                      hint="Ex.: Bloco D apto 504"
                    ></v-text-field>
                  </v-col>
                </div>

            </div>

          </v-container>
        </v-form>
      </v-card-text>

      <v-card-actions>
        <v-container>
          <v-row>
            <v-btn
              class="ml-5"
              @click="$emit('negative')"
              rounded
              depressed
            >
              Cancelar
            </v-btn>
            <v-spacer></v-spacer>
            <v-btn
              class="mr-5"
              @click="$emit('positive', form), $emit('dropModal')"
              dark
              rounded
              depressed
              color="primary"
            >
              Salvar
            </v-btn>
          </v-row>
        </v-container>
      </v-card-actions>
    </v-card>

  </v-dialog>
</template>

<script>
import FilePicker from "@/mixins/FilePicker";
import MenuMixin from "@/mixins/MenuMixin";
import CloudinaryUpload from "@/components/CloudinaryUpload";
import { mask } from 'vue-the-mask'
import { mapState } from 'vuex';
import axios from 'axios';
import moment from 'moment';

export default {
  directives: {
    mask
  },

  components: {
    CloudinaryUpload
  },

  mixins: [FilePicker, MenuMixin],

  props: {
    visibility: Boolean,
    profile: Object,
    isAdmin: Boolean
  },

  data() {
    return {
      dialog: undefined,
      radios: "radio-1",
      date: null,
      menu: false,
      escolaridade: [
        "Ensino Básico Completo",
        "Ensino Médio Incompleto",
        "Ensino Médio Completo",
        "Ensino Superior Incompleto",
        "Ensino Superior Completo",
        "Pós-graduação Incompleta",
        "Pós-graduação Completa"
      ],

      estados_br: [
        "AC",
        "AL",
        "AP",
        "AM",
        "BA",
        "CE",
        "DF",
        "ES",
        "GO",
        "MA",
        "MT",
        "MS",
        "MG",
        "PA",
        "PB",
        "PR",
        "PE",
        "PI",
        "RJ",
        "RN",
        "RS",
        "RO",
        "RR",
        "SC",
        "SP",
        "SE",
        "TO"
      ],

      cidades_br: ["Florianópolis"],
      form: {
        name: undefined,
        email: undefined,
        password: undefined,
        nickname: undefined,
        bith_date: undefined,
        cpf: undefined,
        scholarship: undefined,
        image: undefined,
        cep: '',
        state: '',
        city: '',
        street: '',
        number: '',
        complement: '',
        payment: {
          number: undefined,
          month: undefined,
          year: undefined,
          name: undefined
        },

        new_password: undefined,
        password: undefined,
        password_confirmation: undefined
      },

      cpfMask: "XXX.XXX.XXX-XX",
      phoneMask: "(XX)XXXXXXXXX",
      cepMask: "XXXXX-XXX",
    };
  },
  computed: {
    ...mapState(['affiliates']),
    computedFormatBithDate() {
      moment.locale('pt-BR')
      return this.form.bith_date ? moment(this.form.bith_date).format( 'DD MMM YYYY' ) : ''
    },
  },
  watch: {
    profile: {
      immediate: true,
      handler(newprofile) {

        setTimeout(() => {
          
          if (this.form && this.form.user) this.form.edit_schedule = this.form.user.edit_schedule
        }, 1000);
        if (newprofile) this.form = { ...newprofile };
      }
    }

  },

  mounted() {
    this.dialog = this.visibility;
    if (this.profile) this.form = { ...this.profile };


    setTimeout(() => {
      this.cep(this.form.cep)
    }, 1000);
  },

  methods: {
    async cep(newVal) {
      let splitMask = []
      let valueCep = null

      if (newVal.length === 9) {
        splitMask = newVal.split("-")
      }

      if ( splitMask.length > 0 ) {
          valueCep = splitMask[0] +  splitMask[1]

      } else {
          valueCep = splitMask[0]
      }

      if (valueCep && valueCep.length === 8) {

        let resp = null
        await axios.get(`https://viacep.com.br/ws/${valueCep}/json/`)
        .then(function (response) {
          resp = response
        })
        .catch(function (error) {
          resp = error
        })

        this.form.state = resp.data.uf
        this.form.cep = resp.data.cep;
        this.form.city = resp.data.localidade;
        this.form.street = resp.data.logradouro;
        this.form.neighborhood = resp.data.bairro;
      }
    },

    checkProfessor( status ) {
      this.form.edit_schedule = status
    }
  }

};
</script>

<style scoped>
  .big-purple-text-field >>> .v-text-field__slot input {
    color: #440099;
    font-weight: 700;
  }

  @media (min-width: 767.98px) {
    .big-purple-text-field >>> .v-text-field__slot input {
      font-size: 32px;
    }
  }

  .redux-margin {
    margin-top: -200px !important;
  }

  .width_image {
    width: 120px;
    height: 120px;
  }

</style>


<style>
  .style-floating-action-button {
    position: fixed;
    top: 500px !important;
    left: 90%;
  }

  .style-second-floating-action-button {
    position: fixed;
    top: 500px !important;
    left: 80%;
    color: "grey"
  }

  .font-style {
    font-size: 10px !important;
  }

  @media only screen and (max-height: 590px) {
    .style-floating-action-button {
      position: fixed;
      top: 500px !important;
      left: 90%;
    }

    .style-second-floating-action-button {
      position: fixed;
      top: 500px !important;
      left: 80%;
      color: "grey"
    }
  }

  @media only screen and (max-width: 890px) {
    .style-floating-action-button {
      position: fixed;
      left: 80%;
    }

    .style-second-floating-action-button {
      position: fixed;
      left: 70%;
      color: "grey"
    }
  }

  @media only screen and (max-width: 650px) {
    .style-floating-action-button {
      position: fixed;
      left: 80%;
    }

    .style-second-floating-action-button {
      position: fixed;
      left: 65%;
      color: "grey"
    }
  }

  @media only screen and (max-width: 450px) {
    .style-floating-action-button {
      position: fixed;
      left: 75%;
    }

    .style-second-floating-action-button {
      position: fixed;
      left: 55%;
      color: "grey"
    }
  }

  .position-title-check {
    position: relative;
    top: 50px !important;
  }
</style>
